import React from 'react'
import { DownloadsCategoryModel, DownloadsParent } from '../models/downloads.model'
import { SxProps } from '@mui/system'
import { IconButton } from '@mui/material'
import { J2Editacontent } from '@e3dc-react/icons'
import useModals from 'src/Hooks/useModals'

interface Props {
  item: DownloadsCategoryModel
  parent?: DownloadsParent
  sx?: SxProps
  selectCategory: (categoryId?: number) => void
}

/**
 * Button to edit a download category
 */
const EditDownloadCategoryButton: React.FC<Props> = ({ item, parent, sx, selectCategory }) => {
  const { openDownloadCategoryEditor } = useModals()

  const onClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation()
    openDownloadCategoryEditor({ item, parent, selectCategory })
  }

  return (
    <IconButton sx={sx} onClick={onClick} data-qa={'iconButton-edit-category'}>
      <J2Editacontent />
    </IconButton>
  )
}

export default EditDownloadCategoryButton
